import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskAllTaskReceiver = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskAllTaskReceiver;
